export const countries = [
  { label: 'Deutschland', iso2: 'DE', iso3: 'DEU', carCode: 'D' },
  // A
  { label: 'Afghanistan', iso2: 'AF', iso3: 'AFG', carCode: 'AFG' },
  { label: 'Ägypten', iso2: 'EG', iso3: 'EGY', carCode: 'ET' },
  { label: 'Albanien', iso2: 'AL', iso3: 'ALB', carCode: 'AL' },
  { label: 'Algerien', iso2: 'DZ', iso3: 'DZA', carCode: 'DZ' },
  { label: 'Amerikanisch-Samoa', iso2: 'AS', iso3: 'ASM', carCode: 'USA' },
  { label: 'Amerikanische Jungferninseln', iso2: 'VI', iso3: 'VIR', carCode: '' },
  { label: 'Angola', iso2: 'AO', iso3: 'AGO', carCode: 'ANG' },
  { label: 'Anguilla', iso2: 'AI', iso3: 'AIA', carCode: 'AXA' },
  { label: 'Antarktis', iso2: 'AQ', iso3: 'ATA', carCode: '' },
  { label: 'Antigua und Barbuda', iso2: 'AG', iso3: 'ATG', carCode: 'AG' },
  { label: 'Äquatorialguinea', iso2: 'GQ', iso3: 'GNQ', carCode: 'GQ' },
  { label: 'Argentinien', iso2: 'AR', iso3: 'ARG', carCode: 'RA' },
  { label: 'Armenien', iso2: 'AM', iso3: 'ARM', carCode: 'AM' },
  { label: 'Aruba', iso2: 'AW', iso3: 'ABW', carCode: 'ARU' },
  { label: 'Aserbaidschan', iso2: 'AZ', iso3: 'AZE', carCode: 'AZ' },
  { label: 'Äthiopien', iso2: 'ET', iso3: 'ETH', carCode: 'ETH' },
  { label: 'Australien', iso2: 'AU', iso3: 'AUS', carCode: 'AUS' },
  // B
  { label: 'Bahamas', iso2: 'BS', iso3: 'BHS', carCode: 'BS' },
  { label: 'Bahrain', iso2: 'BH', iso3: 'BHR', carCode: 'BRN' },
  { label: 'Bangladesch', iso2: 'BD', iso3: 'BGD', carCode: 'BD' },
  { label: 'Barbados', iso2: 'BB', iso3: 'BRB', carCode: 'BDS' },
  { label: 'Belarus', iso2: 'BY', iso3: 'BLR', carCode: 'BY' },
  { label: 'Belgien', iso2: 'BE', iso3: 'BEL', carCode: 'B' },
  { label: 'Belize', iso2: 'BZ', iso3: 'BLZ', carCode: 'BZ' },
  { label: 'Benin', iso2: 'BJ', iso3: 'BEN', carCode: 'BJ' },
  { label: 'Bermuda', iso2: 'BM', iso3: 'BMU', carCode: '' },
  { label: 'Bhutan', iso2: 'BT', iso3: 'BTN', carCode: 'BHT' },
  { label: 'Bolivien', iso2: 'BO', iso3: 'BOL', carCode: 'BOL' },
  { label: 'Bosnien und Herzegowina', iso2: 'BA', iso3: 'BIH', carCode: 'BIH' },
  { label: 'Botswana', iso2: 'BW', iso3: 'BWA', carCode: 'RB' },
  { label: 'Bouvetinsel', iso2: 'BV', iso3: 'BVT', carCode: '' },
  { label: 'Brasilien', iso2: 'BR', iso3: 'BRA', carCode: 'BR' },
  { label: 'Britische Jungferninseln', iso2: 'VG', iso3: 'VGB', carCode: 'VG' },
  { label: 'Brunei', iso2: 'BN', iso3: 'BRN', carCode: 'BRU' },
  { label: 'Bulgarien', iso2: 'BG', iso3: 'BGR', carCode: 'BG' },
  { label: 'Burkina Faso', iso2: 'BF', iso3: 'BFA', carCode: 'BF' },
  { label: 'Burundi', iso2: 'BI', iso3: 'BDI', carCode: 'RU' },
  // C
  { label: 'Chile', iso2: 'CL', iso3: 'CHL', carCode: 'RCH' },
  { label: 'China', iso2: 'CN', iso3: 'CHN', carCode: 'CHN' },
  { label: 'Cookinseln', iso2: 'CK', iso3: 'COK', carCode: '' },
  { label: 'Costa Rica', iso2: 'CR', iso3: 'CRI', carCode: 'CR' },
  { label: 'Curaçao', iso2: 'CW', iso3: 'CUW', carCode: '' },
  // D
  { label: 'Dänemark', iso2: 'DK', iso3: 'DNK', carCode: 'DK' },
  { label: 'Demokratische Republik Kongo', iso2: 'CD', iso3: 'COD', carCode: 'CGO' },
  { label: 'Dominica', iso2: 'DM', iso3: 'DMA', carCode: 'WD' },
  { label: 'Dominikanische Republik', iso2: 'DO', iso3: 'DOM', carCode: 'DOM' },
  { label: 'Dschibuti', iso2: 'DJ', iso3: 'DJI', carCode: 'DJI' },
  // E
  { label: 'Ecuador', iso2: 'EC', iso3: 'ECU', carCode: 'EC' },
  { label: 'El Salvador', iso2: 'SV', iso3: 'SLV', carCode: 'ES' },
  { label: 'Elfenbeinküste', iso2: 'CI', iso3: 'CIV', carCode: 'CI' },
  { label: 'Eritrea', iso2: 'ER', iso3: 'ERI', carCode: 'ER' },
  { label: 'Estland', iso2: 'EE', iso3: 'EST', carCode: 'EST' },
  // F
  { label: 'Falklandinseln', iso2: 'FK', iso3: 'FLK', carCode: '' },
  { label: 'Färöer-Inseln', iso2: 'FO', iso3: 'FRO', carCode: 'FO' },
  { label: 'Fidschi', iso2: 'FJ', iso3: 'FJI', carCode: 'FJI' },
  { label: 'Finnland', iso2: 'FI', iso3: 'FIN', carCode: 'FIN' },
  { label: 'Frankreich', iso2: 'FR', iso3: 'FRA', carCode: 'F' },
  { label: 'Französisch-Guayana', iso2: 'GF', iso3: 'GUF', carCode: '' },
  { label: 'Französisch-Polynesien', iso2: 'PF', iso3: 'PYF', carCode: '' },
  // G
  { label: 'Gabun', iso2: 'GA', iso3: 'GAB', carCode: 'G' },
  { label: 'Gambia', iso2: 'GM', iso3: 'GMB', carCode: 'WAG' },
  { label: 'Georgien', iso2: 'GE', iso3: 'GEO', carCode: 'GE' },
  { label: 'Ghana', iso2: 'GH', iso3: 'GHA', carCode: 'GH' },
  { label: 'Gibraltar', iso2: 'GI', iso3: 'GIB', carCode: 'GBZ' },
  { label: 'Grenada', iso2: 'GD', iso3: 'GRD', carCode: 'WG' },
  { label: 'Griechenland', iso2: 'GR', iso3: 'GRC', carCode: 'GR' },
  { label: 'Grönland', iso2: 'GL', iso3: 'GRL', carCode: 'KN' },
  { label: 'Guadeloupe', iso2: 'GP', iso3: 'GLP', carCode: '' },
  { label: 'Guam', iso2: 'GU', iso3: 'GUM', carCode: '' },
  { label: 'Guatemala', iso2: 'GT', iso3: 'GTM', carCode: 'GCA' },
  { label: 'Guinea', iso2: 'GN', iso3: 'GIN', carCode: 'RG' },
  { label: 'Guinea-Bissau', iso2: 'GW', iso3: 'GNB', carCode: 'GUB' },
  { label: 'Guyana', iso2: 'GY', iso3: 'GUY', carCode: 'GUY' },
  // H
  { label: 'Haiti', iso2: 'HT', iso3: 'HTI', carCode: 'RH' },
  { label: 'Honduras', iso2: 'HN', iso3: 'HND', carCode: 'HN' },
  { label: 'Hongkong', iso2: 'HK', iso3: 'HKG', carCode: 'HK' },
  // I
  { label: 'Indien', iso2: 'IN', iso3: 'IND', carCode: 'IND' },
  { label: 'Indonesien', iso2: 'ID', iso3: 'IDN', carCode: 'RI' },
  { label: 'Insel Man', iso2: 'IM', iso3: 'IMN', carCode: '' },
  { label: 'Irak', iso2: 'IQ', iso3: 'IRQ', carCode: 'IRQ' },
  { label: 'Iran', iso2: 'IR', iso3: 'IRN', carCode: 'IR' },
  { label: 'Irland', iso2: 'IE', iso3: 'IRL', carCode: 'IRL' },
  { label: 'Island', iso2: 'IS', iso3: 'ISL', carCode: 'IS' },
  { label: 'Israel', iso2: 'IL', iso3: 'ISR', carCode: 'IL' },
  { label: 'Italien', iso2: 'IT', iso3: 'ITA', carCode: 'I' },
  // J
  { label: 'Jamaika', iso2: 'JM', iso3: 'JAM', carCode: 'JA' },
  { label: 'Japan', iso2: 'JP', iso3: 'JPN', carCode: 'J' },
  { label: 'Jemen', iso2: 'YE', iso3: 'YEM', carCode: 'YEM' },
  { label: 'Jersey', iso2: 'JE', iso3: 'JEY', carCode: 'GBJ' },
  { label: 'Jordanien', iso2: 'JO', iso3: 'JOR', carCode: 'JOR' },
  // K
  { label: 'Kaimaninseln', iso2: 'KY', iso3: 'CYM', carCode: '' },
  { label: 'Kambodscha', iso2: 'KH', iso3: 'KHM', carCode: 'K' },
  { label: 'Kamerun', iso2: 'CM', iso3: 'CMR', carCode: 'CAM' },
  { label: 'Kanada', iso2: 'CA', iso3: 'CAN', carCode: 'CDN' },
  { label: 'Kap Verde', iso2: 'CV', iso3: 'CPV', carCode: 'CV' },
  { label: 'Kasachstan', iso2: 'KZ', iso3: 'KAZ', carCode: 'KZ' },
  { label: 'Katar', iso2: 'QA', iso3: 'QAT', carCode: 'Q' },
  { label: 'Kenia', iso2: 'KE', iso3: 'KEN', carCode: 'EAK' },
  { label: 'Kirgisistan', iso2: 'KG', iso3: 'KGZ', carCode: 'KS' },
  { label: 'Kiribati', iso2: 'KI', iso3: 'KIR', carCode: 'KIR' },
  { label: 'Kokosinseln', iso2: 'CC', iso3: 'CCK', carCode: '' },
  { label: 'Kolumbien', iso2: 'CO', iso3: 'COL', carCode: 'CO' },
  { label: 'Komoren', iso2: 'KM', iso3: 'COM', carCode: 'COM' },
  { label: 'Kosovo', iso2: 'XK', iso3: '', carCode: 'RKS' },
  { label: 'Kroatien', iso2: 'HR', iso3: 'HRV', carCode: 'HR' },
  { label: 'Kuba', iso2: 'CU', iso3: 'CUB', carCode: 'C' },
  { label: 'Kuwait', iso2: 'KW', iso3: 'KWT', carCode: 'KWT' },
  // L
  { label: 'Laos', iso2: 'LA', iso3: 'LAO', carCode: 'LAO' },
  { label: 'Lesotho', iso2: 'LS', iso3: 'LSO', carCode: 'LS' },
  { label: 'Lettland', iso2: 'LV', iso3: 'LVA', carCode: 'LV' },
  { label: 'Libanon', iso2: 'LB', iso3: 'LBN', carCode: 'RL' },
  { label: 'Liberia', iso2: 'LR', iso3: 'LBR', carCode: 'LB' },
  { label: 'Libyen', iso2: 'LY', iso3: 'LBY', carCode: 'LAR' },
  { label: 'Liechtenstein', iso2: 'LI', iso3: 'LIE', carCode: 'FL' },
  { label: 'Litauen', iso2: 'LT', iso3: 'LTU', carCode: 'LT' },
  { label: 'Luxemburg', iso2: 'LU', iso3: 'LUX', carCode: 'L	' },
  // M
  { label: 'Macau', iso2: 'MO', iso3: 'MAC', carCode: '' },
  { label: 'Madagaskar', iso2: 'MG', iso3: 'MDG', carCode: 'RM' },
  { label: 'Malawi', iso2: 'MW', iso3: 'MWI', carCode: 'MW' },
  { label: 'Malaysia', iso2: 'MY', iso3: 'MYS', carCode: 'MAL' },
  { label: 'Malediven', iso2: 'MV', iso3: 'MDV', carCode: 'MV' },
  { label: 'Mali', iso2: 'ML', iso3: 'MLI', carCode: 'RMM' },
  { label: 'Malta', iso2: 'MT', iso3: 'MLT', carCode: 'M' },
  { label: 'Marokko', iso2: 'MA', iso3: 'MAR', carCode: 'MA' },
  { label: 'Marshallinseln', iso2: 'MH', iso3: 'MHL', carCode: 'MH' },
  { label: 'Martinique', iso2: 'MQ', iso3: 'MTQ', carCode: '' },
  { label: 'Mauretanien', iso2: 'MR', iso3: 'MRT', carCode: 'RIM' },
  { label: 'Mauritius', iso2: 'MU', iso3: 'MUS', carCode: 'MS' },
  { label: 'Mayotte', iso2: 'YT', iso3: 'MYT', carCode: '' },
  { label: 'Mazedonien', iso2: 'MK', iso3: 'MKD', carCode: 'MK' },
  { label: 'Mexiko', iso2: 'MX', iso3: 'MEX', carCode: 'MEX' },
  { label: 'Mikronesien', iso2: 'FM', iso3: 'FSM', carCode: 'FSM' },
  { label: 'Moldawien', iso2: 'MD', iso3: 'MDA', carCode: 'MD' },
  { label: 'Monaco', iso2: 'MC', iso3: 'MCO', carCode: 'MD' },
  { label: 'Mongolei', iso2: 'MN', iso3: 'MNG', carCode: 'MGL' },
  { label: 'Montenegro', iso2: 'ME', iso3: 'MNE', carCode: 'MNE' },
  { label: 'Montserrat', iso2: 'MS', iso3: 'MSR', carCode: '' },
  { label: 'Mosambik', iso2: 'MZ', iso3: 'MOZ', carCode: 'MOC' },
  { label: 'Myanmar', iso2: 'MM', iso3: 'MMR', carCode: 'MYA' },
  // N
  { label: 'Namibia', iso2: 'NA', iso3: 'NAM', carCode: 'NAM' },
  { label: 'Nauru', iso2: 'NR', iso3: 'NRU', carCode: 'NAU' },
  { label: 'Nepal', iso2: 'NP', iso3: 'NPL', carCode: 'NEP' },
  { label: 'Neukaledonien', iso2: 'NC', iso3: 'NCL', carCode: 'NCL' },
  { label: 'Neuseeland', iso2: 'NZ', iso3: 'NZL', carCode: 'NZ' },
  { label: 'Nicaragua', iso2: 'NI', iso3: 'NIC', carCode: 'NIC' },
  { label: 'Niederlande', iso2: 'NL', iso3: 'NLD', carCode: 'NL' },
  { label: 'Niederländische Antillen', iso2: 'AN', iso3: 'ANT', carCode: '' },
  { label: 'Niger', iso2: 'NE', iso3: 'NER', carCode: 'RN' },
  { label: 'Nigeria', iso2: 'NG', iso3: 'NGA', carCode: 'NGR' },
  { label: 'Niue', iso2: 'NU', iso3: 'NIU', carCode: '' },
  { label: 'Nördliche Marianen', iso2: 'MP', iso3: 'MNP', carCode: '' },
  { label: 'Nordkorea', iso2: 'KP', iso3: 'PRK', carCode: 'KP' },
  { label: 'Norfolkinsel', iso2: 'NF', iso3: 'NFK', carCode: '' },
  { label: 'Norwegen', iso2: 'NO', iso3: 'NOR', carCode: 'N' },
  // O
  { label: 'Oman', iso2: 'OM', iso3: 'OMN', carCode: 'OM' },
  { label: 'Österreich', iso2: 'AT', iso3: 'AUT', carCode: 'A' },
  { label: 'Osttimor', iso2: 'TL', iso3: 'TLS', carCode: 'TL' },
  // P
  { label: 'Pakistan', iso2: 'PK', iso3: 'PAK', carCode: 'PK' },
  { label: 'Palästina', iso2: 'PS', iso3: 'PSE', carCode: 'WB' },
  { label: 'Palau', iso2: 'PW', iso3: 'PLW', carCode: 'PAL' },
  { label: 'Panama', iso2: 'PA', iso3: 'PAN', carCode: 'PA' },
  { label: 'Papua-Neuguinea', iso2: 'PG', iso3: 'PNG', carCode: 'PNG' },
  { label: 'Paraguay', iso2: 'PY', iso3: 'PRY', carCode: 'PY' },
  { label: 'Peru', iso2: 'PE', iso3: 'PER', carCode: 'PE' },
  { label: 'Philippinen', iso2: 'PH', iso3: 'PHL', carCode: 'RP' },
  { label: 'Polen', iso2: 'PL', iso3: 'POL', carCode: 'PL' },
  { label: 'Portugal', iso2: 'PT', iso3: 'PRT', carCode: 'P' },
  { label: 'Puerto Rico', iso2: 'PR', iso3: 'PRI', carCode: 'PRI' },
  // R
  { label: 'Réunion', iso2: 'RE', iso3: 'REU', carCode: '' },
  { label: 'Republik Kongo', iso2: 'CG', iso3: 'COG', carCode: 'RCB' },
  { label: 'Ruanda', iso2: 'RW', iso3: 'RWA', carCode: 'RWA' },
  { label: 'Rumänien', iso2: 'RO', iso3: 'ROU', carCode: 'RUM' },
  { label: 'Russland', iso2: 'RU', iso3: 'RUS', carCode: 'RUS' },
  // S
  { label: 'Salomonen', iso2: 'SB', iso3: 'SLB', carCode: 'SOL' },
  { label: 'Sambia', iso2: 'ZM', iso3: 'ZMB', carCode: 'Z' },
  { label: 'Samoa', iso2: 'WS', iso3: 'WSM', carCode: 'WS' },
  { label: 'San Marino', iso2: 'SM', iso3: 'SMR', carCode: 'RSM' },
  { label: 'São Tomé und Príncipe', iso2: 'ST', iso3: 'STP', carCode: 'STP' },
  { label: 'Saudi-Arabien', iso2: 'SA', iso3: 'SAU', carCode: 'KSA' },
  { label: 'Schweden', iso2: 'SE', iso3: 'SWE', carCode: 'S' },
  { label: 'Schweiz', iso2: 'CH', iso3: 'CHE', carCode: 'CH' },
  { label: 'Senegal', iso2: 'SN', iso3: 'SEN', carCode: 'SN' },
  { label: 'Serbien', iso2: 'RS', iso3: 'SRB', carCode: 'SRB' },
  { label: 'Seychellen', iso2: 'SC', iso3: 'SYC', carCode: 'SY' },
  { label: 'Sierra Leone', iso2: 'SL', iso3: 'SLE', carCode: 'WAL' },
  { label: 'Simbabwe', iso2: 'ZW', iso3: 'ZWE', carCode: 'ZW' },
  { label: 'Singapur', iso2: 'SG', iso3: 'SGP', carCode: 'SGP' },
  { label: 'Sint Maarten', iso2: 'SX', iso3: 'SXM', carCode: '' },
  { label: 'Slowakei', iso2: 'SK', iso3: 'SVK', carCode: 'SK' },
  { label: 'Slowenien', iso2: 'SI', iso3: 'SVN', carCode: 'SLO' },
  { label: 'Somalia', iso2: 'SO', iso3: 'SOM', carCode: 'SO' },
  { label: 'Spanien', iso2: 'ES', iso3: 'ESP', carCode: 'E' },
  { label: 'Sri Lanka', iso2: 'LK', iso3: 'LKA', carCode: 'CL' },
  { label: 'St. Helena', iso2: 'SH', iso3: 'SHN', carCode: '' },
  { label: 'St. Kitts und Nevis', iso2: 'KN', iso3: 'KNA', carCode: 'KAN' },
  { label: 'St. Lucia', iso2: 'LC', iso3: 'LCA', carCode: 'WL' },
  { label: 'St. Pierre und Miquelon', iso2: 'PM', iso3: 'SPM', carCode: '' },
  { label: 'St. Vincent und die Grenadinen', iso2: 'VC', iso3: 'VCT', carCode: 'WV' },
  { label: 'Südafrika', iso2: 'ZA', iso3: 'ZAF', carCode: 'ZA' },
  { label: 'Südkorea', iso2: 'KR', iso3: 'KOR', carCode: 'ROK' },
  { label: 'Sudan', iso2: 'SD', iso3: 'SDN', carCode: 'SUD' },
  { label: 'Südgeorgien und die Südlichen Sandwichinseln', iso2: 'GS', iso3: 'SGS', carCode: '' },
  { label: 'Südsudan', iso2: 'SS', iso3: 'SSD', carCode: 'SSD' },
  { label: 'Suriname', iso2: 'SR', iso3: 'SUR', carCode: 'SME' },
  { label: 'Swasiland', iso2: 'SZ', iso3: 'SWZ', carCode: '' },
  { label: 'Syrien', iso2: 'SY', iso3: 'SYR', carCode: 'SYR' },
  // T
  { label: 'Tadschikistan', iso2: 'TJ', iso3: 'TJK', carCode: 'TJ' },
  { label: 'Taiwan', iso2: 'TW', iso3: 'TWN', carCode: 'RC' },
  { label: 'Tansania', iso2: 'TZ', iso3: 'TZA', carCode: 'EAT' },
  { label: 'Thailand', iso2: 'TH', iso3: 'THA', carCode: 'T' },
  { label: 'Togo', iso2: 'TG', iso3: 'TGO', carCode: 'TG' },
  { label: 'Tokelau', iso2: 'TK', iso3: 'TKL', carCode: '' },
  { label: 'Tonga', iso2: 'TO', iso3: 'TON', carCode: 'TON' },
  { label: 'Trinidad und Tobago', iso2: 'TT', iso3: 'TTO', carCode: 'TT' },
  { label: 'Tschad', iso2: 'TD', iso3: 'TCD', carCode: 'TD' },
  { label: 'Tschechien', iso2: 'CZ', iso3: 'CZE', carCode: 'CZ' },
  { label: 'Tunesien', iso2: 'TN', iso3: 'TUN', carCode: 'TN' },
  { label: 'Türkei', iso2: 'TR', iso3: 'TUR', carCode: 'TR' },
  { label: 'Turkmenistan', iso2: 'TM', iso3: 'TKM', carCode: 'TM' },
  { label: 'Turks- und Caicosinseln', iso2: 'TC', iso3: 'TCA', carCode: '' },
  { label: 'Tuvalu', iso2: 'TV', iso3: 'TUV', carCode: 'TUV' },
  // U
  { label: 'Uganda', iso2: 'UG', iso3: 'UGA', carCode: 'UA' },
  { label: 'Ukraine', iso2: 'UA', iso3: 'UKR', carCode: 'UA' },
  { label: 'Ungarn', iso2: 'HU', iso3: 'HUN', carCode: 'H' },
  { label: 'Uruguay', iso2: 'UY', iso3: 'URY', carCode: 'ROU' },
  { label: 'Usbekistan', iso2: 'UZ', iso3: 'UZB', carCode: 'UZ' },
  // V
  { label: 'Vanuatu', iso2: 'VU', iso3: 'VUT', carCode: 'VAN' },
  { label: 'Vatikanstadt', iso2: 'VA', iso3: 'VAT', carCode: 'V' },
  { label: 'Venezuela', iso2: 'VE', iso3: 'VEN', carCode: 'YV' },
  { label: 'Vereinigte Arabische Emirate', iso2: 'AE', iso3: 'ARE', carCode: 'UAE' },
  { label: 'Vereinigte Staaten von Amerika', iso2: 'US', iso3: 'USA', carCode: 'USA' },
  { label: 'Vereinigtes Königreich', iso2: 'GB', iso3: 'GBR', carCode: 'GBM' },
  { label: 'Vietnam', iso2: 'VN', iso3: 'VNM', carCode: 'VN' },
  // W
  { label: 'Wallis und Futuna', iso2: 'WF', iso3: 'WLF', carCode: '' },
  { label: 'Weihnachtsinsel', iso2: 'CX', iso3: 'CXR', carCode: '' },
  { label: 'Westsahara', iso2: 'EH', iso3: 'ESH', carCode: 'WSA' },
  // Z
  { label: 'Zentralafrikanische Republik', iso2: 'CF', iso3: 'CAF', carCode: 'RCA' },
  { label: 'Zypern', iso2: 'CY', iso3: 'CYP', carCode: 'CY' },
]
